import type { ProbablyDate } from "@eroad/types";

import { isDefined } from "../utils/isDefined";
import { dayjs } from "./dayjs";

/**
 * Type guard to check whether the provided value can be transformed into a valid Date object.
 *
 * @example
 * ```ts
 * canBeValidDate(Date.now());
 * canBeValidDate(new Date(2023-12-10T12:45:00+13:00));
 * canBeValidDate("2023-10-01T12:00:00Z");
 * canBeValidDate(1640995200000);
 * ```
 */
function canBeValidDate<T extends ProbablyDate>(value: T): value is NonNullable<T> {
  if (!isDefined(value)) {
    return false;
  }

  return dayjs(value).isValid();
}

export { canBeValidDate };
